import {action, makeObservable, observable, runInAction} from 'mobx';
import {decorate, inject, injectable} from '@yosmanyga/di';
import {PaymentApi} from '@yosmanyga/fortaleza-core';

class PaymentController {
    loaded: boolean;
    version!: string;

    percent!: string;
    price!: number;
    url!: string;

    constructor(
        private paymentApi: PaymentApi
    ) {
        this.loaded = false;

        makeObservable(this, {
            loaded: observable,
            version: observable,
            url: observable,
            load: action,
        })
    }

    load = async () => {
        const {price, percent, url} = await this.paymentApi.init();

        runInAction(() => {
            this.price = price;
            this.percent = percent;
            this.url = url;
            this.loaded = true;
        });
    };
}

decorate(injectable(), PaymentController);
decorate(inject(PaymentApi), PaymentController, 0);

export {PaymentController};
